import React from "react";
import Icon from "components/AppIcon";

const RecommendedStartingPath = ({ path }) => {
  return (
    <section className="rounded-2xl border shadow-sm p-6 md:p-8 lg:p-10 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #283ba3 0%, #1e2d7a 100%)", borderColor: "transparent" }}>
      <div className="absolute top-0 right-0 w-48 h-48 rounded-full opacity-10" style={{ background: "radial-gradient(circle, #d3ac35 0%, transparent 70%)", transform: "translate(30%, -30%)" }} aria-hidden="true" />
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(211,172,53,0.2)" }}>
            <Icon name="Target" size={22} color="#d3ac35" strokeWidth={2} />
          </div>
          <div>
            <p className="text-xs font-medium uppercase tracking-widest" style={{ color: "#d3ac35", fontFamily: "var(--font-caption)" }}>Section 3</p>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-white" style={{ fontFamily: "var(--font-heading)" }}>Recommended Starting Path</h2>
          </div>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 mb-5 border border-white/20">
          <h3 className="text-lg md:text-xl font-bold text-white mb-2" style={{ fontFamily: "var(--font-heading)", fontWeight: 700 }}>{path?.title}</h3>
          <p className="text-sm md:text-base text-white/80 leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>{path?.description}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="rounded-xl p-4 border border-white/15" style={{ backgroundColor: "rgba(255,255,255,0.08)" }}>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="CheckCircle" size={16} color="#d3ac35" strokeWidth={2} />
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: "#d3ac35", fontFamily: "var(--font-caption)" }}>Why It Fits You</p>
            </div>
            <p className="text-sm text-white/80" style={{ fontFamily: "var(--font-body)" }}>{path?.whyItFits}</p>
          </div>
          <div className="rounded-xl p-4 border border-white/15" style={{ backgroundColor: "rgba(255,255,255,0.08)" }}>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="DollarSign" size={16} color="#d3ac35" strokeWidth={2} />
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: "#d3ac35", fontFamily: "var(--font-caption)" }}>How It Generates Income</p>
            </div>
            <p className="text-sm text-white/80" style={{ fontFamily: "var(--font-body)" }}>{path?.howItGeneratesIncome}</p>
          </div>
          <div className="rounded-xl p-4 border border-white/15" style={{ backgroundColor: "rgba(255,255,255,0.08)" }}>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Calendar" size={16} color="#d3ac35" strokeWidth={2} />
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: "#d3ac35", fontFamily: "var(--font-caption)" }}>30-Day Feasibility</p>
            </div>
            <p className="text-sm text-white/80" style={{ fontFamily: "var(--font-body)" }}>{path?.feasibility}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecommendedStartingPath;